import { render, staticRenderFns } from "./DescriptionListItem.vue?vue&type=template&id=00b27dbe&"
import script from "./DescriptionListItem.vue?vue&type=script&lang=ts&"
export * from "./DescriptionListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports